module.exports = __webpack_public_path__ + "img/jam10.875b70d6.jpg";